import PropTypes from "prop-types"

export const childImageSharpType = PropTypes.shape({
  childImageSharp: PropTypes.shape({
    gatsbyImageData: PropTypes.shape({
      backgroundColor: PropTypes.string,
      height: PropTypes.number,
      images: PropTypes.shape({
        fallback: PropTypes.shape({
          sizes: PropTypes.string,
          src: PropTypes.string,
          srcSet: PropTypes.string,
        }),
        sources: PropTypes.array,
      }),
      layout: PropTypes.string,
      width: PropTypes.number,
    }),
  }),
})

export const branchRecordType = PropTypes.shape({
  id: PropTypes.string,
  name: PropTypes.string,
  regulatoryId: PropTypes.string,
  regulatoryBody: PropTypes.string,
  latestInspectionRating: PropTypes.string,
  phoneNumber: PropTypes.string,
  numberOfBeds: PropTypes.number,
  numberOfBedsInSingleRooms: PropTypes.number,
  numberOfBedsInDoubleRooms: PropTypes.number,
  numberOfBedsWithEnsuite: PropTypes.number,
  dateOpened: PropTypes.string,
  careType: PropTypes.oneOf(["home_care", "care_home"]),
  careProvider: PropTypes.shape({
    id: PropTypes.string,
    careServices: PropTypes.arrayOf(PropTypes.string),
    info: PropTypes.string,
    currentAvailability: PropTypes.bool,
    displayPhoneNumber: PropTypes.string,
    chStartingWeeklyRate: PropTypes.number,
    photos: PropTypes.array,
    photoCount: PropTypes.number,
    hasVideo: PropTypes.bool,
    logoUrl: PropTypes.string,
    coverPhotoUrl: PropTypes.string,
    coverPhoto: childImageSharpType,
  }),
  careServiceTypes: PropTypes.arrayOf(PropTypes.string),
  address: PropTypes.shape({
    streetAddress1: PropTypes.string,
    streetAddress2: PropTypes.string,
    city: PropTypes.string,
    postcode: PropTypes.string,
  }),
})
